module.exports = __webpack_public_path__ + "static/bg01-be11d3bd0ad5768dd1962cc2558db7fe.jpg";